import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Product, ProductListByIdsComponent, ProductListByIdsConfigService, ProductService } from 'gung-standard';
import { CarLinerProductListByIdsAddonsConfigService } from '../../services/car-liner-product-list-by-ids-addons-config.service';
import { FilterListComponent } from 'gung-list';

@Component({
    selector: 'car-liner-product-list-by-ids',
    template: '<lib-filter-list #productList [configService]="configService"></lib-filter-list>',
    styleUrls: ['./car-liner-product-list-by-ids.component.scss'],
    standalone: false
})
export class CarLinerProductListByIdsComponent implements OnInit {
  @ViewChild('productList') productList: FilterListComponent<Product>;

  @Input()
  product: Product
  @Input()
  isAddons: boolean;

  @Input()
  recommendedQuantities: { [productId: string]: number };

  @Input()
  private _productIds: string[];

  @Input() set productIds(value: string[] | string) {
    if (value && !Array.isArray(value)) {
      value = value.split(',');
    }
    if (this.isArrayIdenticalToProductIds(value)) {
      return;
    }
    this._productIds = value as string[];
    this.configService.setSubscriptionIds(this._productIds);
  }

  @Input() set productIdsCSS(values: string) {
    let idsArray = [];
    if (values) {
      idsArray = values.split(',');
    }
    if (this.isArrayIdenticalToProductIds(idsArray)) {
      return;
    }
    this._productIds = idsArray;
    this.configService.setSubscriptionIds(this._productIds);
  }

  isArrayIdenticalToProductIds(idsArray): boolean {
    if (
      this._productIds &&
      idsArray &&
      this._productIds.length === idsArray.length &&
      this._productIds.every((ele, index) => ele === idsArray[index])
    ) {
      return true;
    }
    return false;
  }

  constructor(
    protected productService: ProductService,
    protected configService: CarLinerProductListByIdsAddonsConfigService
  ) { }

  ngOnInit() {
    this.configService.masterProduct = this.product;
    this.configService.isAddons = this.isAddons;
    this.configService.recommendedQuantities = this.recommendedQuantities;
  }
}
